import { RemoteGetMetersByStatus } from "../../../../data/usecases/meter/remote-get-meters-by-status";
import { GetMetersByStatus } from "../../../../domain/usecases/get-meters-by-status";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteGetMetersByStatus = (): GetMetersByStatus =>
  new RemoteGetMetersByStatus(
    makeApiUrl("/meters/get-meters-by-status"),
    makeAxiosHttpClient()
  );
